import { UserRole } from './core';

/** Global platform operators (unrestricted property scope when combined with auth middleware). */
export function isGlobalPlatformOperatorRole(role: UserRole): boolean {
  return role === UserRole.SYSTEM_ADMIN || role === UserRole.PLATFORM_ADMIN || role === UserRole.ADMIN;
}
